import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import "emoji-mart/css/emoji-mart.css";
import {
  FormHelperText,
  withStyles
} from "@material-ui/core";
import countWithEmojis from "../functions/countWithEmojis";
import { Editor } from '@tinymce/tinymce-react';

const styles = theme => ({
  "@global": {
    ".emoji-mart-category-label": theme.typography.body1,
    ".emoji-mart-bar": { display: "none !important" },
    ".emoji-mart-search input": {
      ...theme.typography.body1,
      ...theme.border
    },
    ".emoji-mart-search": {
      marginTop: `${theme.spacing(1)}px !important`,
      paddingRight: `${theme.spacing(1)}px !important`,
      paddingLeft: `${theme.spacing(1)}px !important`,
      paddingBottom: `${theme.spacing(1)}px !important`
    },
    ".emoji-mart-search-icon": {
      top: "5px !important",
      right: "14px !important",
      fontSize: 20
    },
    ".emoji-mart-scroll": {
      height: 240
    },
    ".emoji-mart": {
      ...theme.border
    }
  },
  floatButtonWrapper: {
    position: "absolute",
    bottom: 12,
    right: 12
  },
  floatButtonSVG: {
    color: theme.palette.primary.light
  },
  relative: {
    position: "relative"
  }
});

class EmojiTextarea extends PureComponent {
  state = {
    characters: 0
  };

  handleTextFieldChange = (value, editor) => {
    const { maxCharacters, onChange, input } = this.props;
    let characters;
    if (maxCharacters) {
      characters = countWithEmojis(value);
      if (characters > maxCharacters) {
        value = value.substring(0, maxCharacters);
      }
    }
    if (onChange) {
      onChange(value, characters);
    }
    this.setState({ value, characters });
    input.onChange(value);
  };

  render() {
    const { characters } = this.state;
    const {
      //classes,
      placeholder,
      maxCharacters,
      input
    } = this.props;
    return (
      <Fragment>
        <Editor
          apiKey="8p0ik9lso2qjl3edpl69i3zfidwgfjbawhk3qorpzqu1fizf" /*registered with account info@roxcode.com */
          placeholder={placeholder}
          init={{
            fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
            height: 200,
            menubar: false,
            plugins: [
              'emoticons advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help'
            ],
            toolbar:
              'emoticons undo redo | formatselect | fontsizeselect | bold italic backcolor | link | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
          }}
          onEditorChange={this.handleTextFieldChange}
          value={input.value}
          textareaName={input.name}
        /* initialValue={value} no need for this, since react form final sets the value */
        /* {...input} // this makes the text disappear the first time it's edited, also react form final doesn't get the value. */
        />

        {maxCharacters && (
          <FormHelperText error={characters >= maxCharacters}>
            {`${characters}/${maxCharacters} characters`}
          </FormHelperText>
        )}
      </Fragment>
    );
  }
}

EmojiTextarea.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  emojiSet: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  maxCharacters: PropTypes.number,
  onChange: PropTypes.func,
  inputClassName: PropTypes.string
};

export default withStyles(styles, { withTheme: true })(EmojiTextarea);
